module.exports = __webpack_public_path__ + "img/bg-datacenter.bbc6e5f.png";